import type { PartnerResDto, PartnerInfoResDto, PartnerLoginReqDto } from './type';

import { request, endpoints } from 'src/lib/axios';

export const partnerLogin = async (
  requestBody: PartnerLoginReqDto,
) => {
  const response = await request<PartnerLoginReqDto, PartnerResDto>({
    method: 'post',
    url: endpoints.partner.login,
    requestBody,
  });

  return response;
};

export const partnerInfo = async () => {
  const response = await request<void, PartnerInfoResDto>({
    method: 'get',
    url: endpoints.partner.info,
  });

  return response;
};